import { c as _c } from "react/compiler-runtime";
import { ArrowDownIcon, TextVariant, Text, Tooltip } from "@flat-ui";
import { ButtonBase } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Export button styled for selected items export.
 * Displays the label text followed by an arrow down icon that rotates when the menu is open.
 */
export function SphereDropdownButton(t0) {
  const $ = _c(19);
  const {
    isOpen,
    onClick,
    label,
    buttonTooltipText,
    variant: t1,
    iconColor: t2,
    sxLabel
  } = t0;
  const variant = t1 === undefined ? TextVariant.bodyM : t1;
  const iconColor = t2 === undefined ? PALETTE_VARS.text.primary : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      gap: "0.375rem"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== sxLabel) {
    t5 = {
      ...sxLabel
    };
    $[2] = sxLabel;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== label || $[5] !== t5 || $[6] !== variant) {
    t6 = <Text variant={variant} sx={t5}>{label}</Text>;
    $[4] = label;
    $[5] = t5;
    $[6] = variant;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isOpen ? "rotate(180deg)" : "rotate(0deg)";
  let t8;
  if ($[8] !== iconColor || $[9] !== t7) {
    t8 = <ArrowDownIcon data-testid="dropdown-selector-arrow" sx={{
      width: "1rem",
      height: "1rem",
      transform: t7,
      transition: "transform 0.2s ease-in-out",
      color: iconColor
    }} />;
    $[8] = iconColor;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isOpen || $[12] !== onClick || $[13] !== t6 || $[14] !== t8) {
    t9 = <ButtonBase sx={t4} aria-haspopup="listbox" aria-expanded={isOpen} onClick={onClick}>{t6}{t8}</ButtonBase>;
    $[11] = isOpen;
    $[12] = onClick;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== buttonTooltipText || $[17] !== t9) {
    t10 = <Tooltip component="div" title={buttonTooltipText} sx={t3}>{t9}</Tooltip>;
    $[16] = buttonTooltipText;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}